import React, { useCallback } from 'react'
import DownloadsNavButton from '../../components/Navigation/DownloadsNavButton'
import { getLogger } from '@chilecompra/react-kit/debuggers'
import { REACT_APP_MP_URL, REACT_APP_TCHC_BLOB_URL } from '../../config/settings/environment'
import {
  Description,
  GridContainer,
  GridItem,
  Root,
  Subtitle,
  Title,
  Value,
  MiniClipboardIcon,
  Clipboard,
  ClipboardAction,
  ClipboardIcon,
  ClipboardText,
  Label,
  Strong,
  Key,
  Link,
  OrderedList,
  UnorderedList,
  ListItem,
  Break
} from './DownloadAgilePurchaseSection.styles'
/**
 * The DownloadAgilePurchaseSection's container.
 */
const DownloadAgilePurchaseSection = () => {
  const logger = getLogger('DOWNLOADS_CLIPBOARD')
  const baseUrl = `${REACT_APP_TCHC_BLOB_URL}/trnspchc/COT_`
  const handleClipboardFallback = useCallback(content => {
    const textAreaElement = document.createElement('textarea')

    textAreaElement.value = content
    textAreaElement.style.top = '0'
    textAreaElement.style.left = '0'
    textAreaElement.style.position = 'fixed'

    document.body.appendChild(textAreaElement)
    textAreaElement.focus()
    textAreaElement.select()

    document.body.removeChild(textAreaElement)
  }, [])
  const handleDoubleClickClipboard = content => () => {
    if (!window.navigator.clipboard) {
      return handleClipboardFallback(content)
    }

    window.navigator.clipboard
      .writeText(content)
      .then(() => logger.info('Clipboard: copying to clipboard was successful'))
      .catch(error => logger.error('Clipboard: could not copy content', error))
  }

  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <DownloadsNavButton />
        <GridItem xs={10} sm={11}>
          <Title> Compra Ágil</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 17px">
        <GridItem xs={12}>
          <Description>
            La Compra Ágil es un procedimiento para compras menores a 30 UTM y se inicia cuando el organismo comprador
            realiza múltiples solicitudes de cotización a proveedores inscritos en{' '}
            <Link href={REACT_APP_MP_URL}>www.mercadopublico.cl</Link> según los rubros declarados por cada uno de
            estos. En esta sección se presentan links de descarga con todos los registros de cotizaciones mensuales
            respondidas por proveedores a cada comprador que publicó un requerimiento en el módulo de Compra Ágil.
            Mensualmente quedará a disposición un nuevo link con los registros del mes anterior. Cabe mencionar que este
            procedimiento se encuentra vigente desde el año 2020.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 23px">
        <GridItem xs={12}>
          <Key>Cotizaciones Compra Ágil:</Key>
        </GridItem>
        <GridItem xs={12}>
          <Value onDoubleClick={handleDoubleClickClipboard(`${baseUrl}{año}-{mes}.zip`)}>
            {`${baseUrl}{año}-{mes}.zip`}
            <MiniClipboardIcon />
          </Value>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 16px">
        <GridItem xs={12}>
          <Subtitle>Modo de Uso</Subtitle>
          <br />
          <Description>
            Para usar cada una de estas consultas, es necesario:
            <OrderedList>
              <ListItem>
                Copiar la siguiente url y pegarla en una nueva página:
                <Break />
                <Value onDoubleClick={handleDoubleClickClipboard(`${baseUrl}{año}-{mes}.zip`)}>
                  {`${baseUrl}{año}-{mes}.zip`}
                  <MiniClipboardIcon />
                </Value>
              </ListItem>
              <Break />
              <ListItem>
                Completar los parámetros que se encuentran encerrados en llaves: año, mes. La definición de estos
                parametros es la siguiente:
                <UnorderedList>
                  <ListItem>
                    <Strong>Año</Strong>: Año en que fue publicada la solicitud de cotización.
                  </ListItem>
                  <ListItem>
                    <Strong>Mes</Strong>: Mes en que fue publicada la solicitud de cotización.
                  </ListItem>
                </UnorderedList>
              </ListItem>
            </OrderedList>
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer alignItems="center" padding="0 0 21px">
        <GridItem xs={12}>
          El siguiente ejemplo entrega las cotizaciones del mes de enero de 2022.
          <br />
          <br />
          <Label>Ejemplo:</Label>
          <Clipboard onDoubleClick={handleDoubleClickClipboard(`${baseUrl}{año}/{mes}.zip`)}>
            <ClipboardText>{baseUrl}2022-01.zip</ClipboardText>
            <ClipboardAction>
              <ClipboardIcon />
            </ClipboardAction>
          </Clipboard>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default DownloadAgilePurchaseSection
